import React, { Component } from 'react'

import { Table, Input, InputNumber, Tag, Space, Button, Row, Col, Drawer, Select, Spin, Switch, message } from "antd";
import { updateGenHutDetails } from "../../api/index";

class GeneratorHut extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            tabaleLoading: false,
            switchStatus: true,
            setAvailableGeneratorHut1Type: null,
            setAvailableGeneratorHut2Type: null,
            objectSet: { "SpaceAvailableNewGen": false, "NumberofGeneratorHut": null, "availableGeneratorHut1Type": null, "availableGeneratorHut2Type": null },
            dropdownObjGenHut: {
                "SpaceAvailableNewGen": "",
                "NumberofGeneratorHut": "",
                "availableGeneratorHut1Type": "",
                "availableGeneratorHut2Type": ""
            }
        };
        this.handlNofgenGut = this.handlNofgenGut.bind(this);
        this.onChangehenHut1type = this.onChangehenHut1type.bind(this);
        this.onChangehenHut2type = this.onChangehenHut2type.bind(this);
        this.onChangehenIsAvabel = this.onChangehenIsAvabel.bind(this);

    }
    onChangehenIsAvabel(value) {
        this.setState({
            objectSet: {
                ...this.state.objectSet,
                SpaceAvailableNewGen:value
            }
        })
    }
    onChangehenHut2type(value) {
        this.setState({
            objectSet: {
                ...this.state.objectSet,
                availableGeneratorHut2Type: { "id": value }
            }
        })
    }
    onChangehenHut1type(value) {
        this.setState({
            objectSet: {
                ...this.state.objectSet,
                availableGeneratorHut1Type: { "id": value }
            }
        })
    }

    handlNofgenGut(e) {
        console.log(e)


        this.setState({
            objectSet: {
                ...this.state.objectSet,
                NumberofGeneratorHut: e
            }

        }, () => {
            console.log(this.state.objectSet)
        })
    }

    componentDidMount() {
        console.log('7985255')
        console.log(this.props.genHutMastetData.typeSet)

        this.setState({

        })

        this.setState({
            objectSet: { "SpaceAvailableNewGen": this.props.details3?.allData?.isSpaceAvailableNewGen, "NumberofGeneratorHut": this.props.details3?.allData?.numberofGeneratorHut, "availableGeneratorHut1Type": this.props.details3?.allData?.availableGeneratorHut1Type != null ? ({ 'id': this.props.details3?.allData?.availableGeneratorHut1Type?.id }) : (null), "availableGeneratorHut2Type": this.props.details3?.allData?.availableGeneratorHut2Type != null ? ({ 'id': this.props.details3?.allData?.availableGeneratorHut2Type?.id }) : (null) }

        });
        // console.log(this.props.details2)
    }
    dataUpdate() {
        console.log("ssss")
        this.setState({
            switchStatus: false
        })
    }
    close = async () => {
        this.props.parentMethod();
        this.setState({
            objectSet: { "SpaceAvailableNewGen": this.props.details3?.allData?.isSpaceAvailableNewGen, "NumberofGeneratorHut": this.props.details3?.allData?.numberofGeneratorHut, "availableGeneratorHut1Type": this.props.details3?.allData?.availableGeneratorHut1Type != null ? ({ 'id': this.props.details3?.allData?.availableGeneratorHut1Type?.id }) : (null), "availableGeneratorHut2Type": this.props.details3?.allData?.availableGeneratorHut2Type != null ? ({ 'id': this.props.details3?.allData?.availableGeneratorHut2Type?.id }) : (null) }

        });
        this.setState({
            switchStatus: true
        });
    }
    dataSetToUpdate = async () => {
        console.log(this.props.detailsSite)
        let formData = new FormData(); //formdata object
        let setobjectToUpate = {"isSpaceAvailableNewGen":this.state.objectSet.SpaceAvailableNewGen,"numberofGeneratorHut":this.state.objectSet.NumberofGeneratorHut,"availableGeneratorHut1Type":this.state.objectSet.availableGeneratorHut1Type,"availableGeneratorHut2Type":this.state.objectSet.availableGeneratorHut2Type}
        console.log(setobjectToUpate)
        formData.append("object", JSON.stringify(setobjectToUpate)); //append the values with key, value pair
        formData.append("id", this.props.detailsSite.site_details.id);
        var res = await updateGenHutDetails(formData);
        if(res.success){
            message.success('Successfully Update!')
            this.props.parentMethod();
            this.setState({
              switchStatus: true
          })
         }else{
          message.warning(' Something went wrong!')
         }





    }
    render() {
        const { Option } = Select;
        const { details } = this.props.details

        return (
            <>
                {this.props.details.access_technologies_data != null ? (
                    <div className='row'>
                        <div className='col-md-5'>
                            <div class="card">
                                <div class="card-header">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <h4 class="card-title">Information</h4>
                                        {this.state.switchStatus
                                            ? <button type="button" class="btn btn-soft-primary btn-icon-square-sm" onClick={() => this.dataUpdate()}> <i class="mdi mdi-pencil-outline"></i></button>
                                            : <div class="d-flex justify-content-end align-items-center">
                                                <button type="button" class="btn btn-soft-secondary " onClick={() => this.close()} style={{ marginRight: "10px" }}> Cancel </button>
                                                <button type="button" class="btn btn-soft-primary " onClick={() => this.dataSetToUpdate()}> Submit to Update </button>
                                            </div>
                                        }
                                    </div>

                                </div>
                                <div class="card-body">
                                    <div class="row">

                                        <ul class="list-group">
                                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                                <div>
                                                    <i class="la la-hand-o-right text-primary me-2"></i>Number of Generator Hut
                                                </div>
                                                {/* {this.props.details3?.allData?.numberofGeneratorHut ? (<span class="badge badge-outline-success">{this.props.details3?.allData?.isIdleGeneratorHutAvaialable}</span>) : (<span class="badge badge-outline-warning">{JSON.stringify(this.props.details3?.allData?.isIdleGeneratorHutAvaialable)}</span>)} */}
                                                {/* {this.state.switchStatus ? (<> {this.props.details3?.allData?.numberofGeneratorHut != null ? (<span class="badge badge-outline-success">{this.props.details3?.allData?.numberofGeneratorHut}</span>) : (<span class="badge badge-outline-warning">Currently Not Set</span>)}</>) : (<> <InputNumber style={{ width: '20%' }} value={this.state.objectSet?.NumberofGeneratorHut} id="mpcNoOfPhases" onChange={this.handlNofgenGut} /> </>)} */}
                                                <div>
                                                        {this.state.switchStatus.toString() == "true" ? (
                                                            this.props.details3?.allData?.numberofGeneratorHut ?(
                                                                <span class="badge badge-outline-success">{this.props.details3?.allData?.numberofGeneratorHut}</span>
                                                            ) : (
                                                                <span class="badge badge-outline-danger">Currently Not Set</span>
                                                            )
                                                        ) : (
                                                            <Select
                                                                defaultValue={this.props.details3?.allData?.numberofGeneratorHut}
                                                                style={{ width: 140 }}
                                                                onChange={(e) => {
                                                                    this.state.objectSet.NumberofGeneratorHut = e;
                                                                }}>
                                                                {this.props.dropdownGenhut["dropdownObjGenHut"]["NumberofGeneratorHut"].map((x) => {
                                                                    return <Option value={x}>{x}</Option>
                                                                })}
                                                            </Select>
                                                        )}
                                                    </div>
                                            </li>
                                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                                <div>
                                                    <i class="la la-hand-o-right text-primary me-2"></i>Available Generator Hut 1 type
                                                </div>
                                                {this.state.switchStatus
                                                    ? (<> {this.props.details3?.allData?.availableGeneratorHut1Type != null ? (<span class="badge badge-outline-success">{this.props.details3?.allData?.availableGeneratorHut1Type?.name}</span>) : (<span class="badge badge-outline-danger">Currently Not Set</span>)}</>)
                                                    : (<Select
                                                        showSearch
                                                        onChange={this.onChangehenHut1type}
                                                        defaultValue={this.props.details3?.allData?.availableGeneratorHut1Type?.id}
                                                        style={{ width: 140 }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                    >
                                                        {this.props.genHutMastetData.typeSet?.map((item, index) => {
                                                            return <Option value={item?.id}>{item.name}</Option>;
                                                        })}
                                                    </Select>)}
                                            </li>
                                            <li class=
                                            "list-group-item d-flex justify-content-between align-items-center">
                                                <div>
                                                    <i class="la la-hand-o-right text-primary me-2"></i>available Generator Hut 2 type
                                                </div>

                                                {/* {this.state.switchStatus ? (<> {this.props.details3?.allData?.availableGeneratorHut2Type != null ? (<span class="badge badge-outline-success">{this.props.details3?.allData?.availableGeneratorHut2Type.name}</span>) : (<span class="badge badge-outline-warning">Currently Not Set</span>)}</>) : (<> <InputNumber style={{ width: '20%' }} value={this.state.objectSet?.availableGeneratorHut2Type?.name} id="mpcNoOfPhases" onChange={this.handlNofgenGut} /> </>)} */}
                                                {this.state.switchStatus
                                                    ? (<> {this.props.details3?.allData?.availableGeneratorHut2Type != null ? (<span class="badge badge-outline-success">{this.props.details3?.allData?.availableGeneratorHut2Type?.name}</span>) : (<span class="badge badge-outline-danger">Currently Not Set</span>)}</>)
                                                    : (<Select
                                                        showSearch
                                                        onChange={this.onChangehenHut2type}
                                                        defaultValue={this.props.details3?.allData?.availableGeneratorHut2Type?.id}
                                                        style={{ width: 140 }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                    >
                                                        {this.props.genHutMastetData.typeSet?.map((item, index) => {
                                                            return <Option value={item?.id}>{item.name}</Option>;
                                                        })}
                                                    </Select>)}

                                            </li>
                                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                                <div>
                                                    <i class="la la-hand-o-right text-primary me-2"></i>Generator space availability for a new generator
                                                </div>

                                                {/* {this.props.details3?.allData?.isSpaceAvailableNewGen ? (<span class="badge badge-outline-success">{this.props.details3?.allData?.isSpaceAvailableNewGen}</span>) : (<span class="badge badge-outline-warning">{JSON.stringify(this.props.details3?.allData?.isSpaceAvailableNewGen)}</span>)} */}
                                                {this.state.switchStatus
                                                    ? (<> {this.props.details3?.allData?.isSpaceAvailableNewGen != null ? (<span class="badge badge-outline-success">{this.props.details3?.allData?.isSpaceAvailableNewGen?('Yes'):('No')}</span>) : (<span class="badge badge-outline-danger">Currently Not Set</span>)}</>)
                                                    : (<Select
                                                        showSearch
                                                        onChange={this.onChangehenIsAvabel}
                                                        defaultValue={this.props.details3?.allData?.isSpaceAvailableNewGen}
                                                        style={{ width: 140 }}
                                                        placeholder="Search to Select"
                                                        optionFilterProp="children"
                                                    >
                                                       <Option value={1}>Yes</Option>
                                                       <Option value={0}>No</Option>
                                                    </Select>)}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-7'>


                            {/* {this.props.details2.generators_data.length > 0 ? (<div class="card">
                                <div class="card-header">
                                    <h4 class="card-title">Generators</h4>

                                </div>
                                <div class="card-body">
                                <Table
                                size="small"
                                columns={columns2}
                                // loading={this.state.loading && this.state.rectifierloading && this.state.batteryBanksloading && this.state.airConditionersloading && this.state.spdsloading && this.state.cabinetsloading && this.state.generatorsloading && this.state.atsesloading && this.state.dcdusloading && this.state.fcbsloading && this.state.sharedOutOperatorsesloading}
                                loading={this.state.tabaleLoading}
                                dataSource={this.props.details2.generators_data}
                                scroll={{
                                    x: 1300,
                                }}
                            />
                            </div>
                            </div>) : ('')} */}



                        </div>
                    </div>
                ) : (<div style={{ height: '120px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <h4 style={{ color: "#c5c5c5" }}>No Dat Found Access Technologies</h4></div>)}

            </>
        )
    }
}
export default GeneratorHut;
